webpackJsonp([145880425087474],{

/***/ 437:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"totalCount":5,"edges":[{"node":{"frontmatter":{"title":"The Kingkiller Chronicle","path":"/kingkiller"}}},{"node":{"frontmatter":{"title":"Mistborn","path":"/mistborn"}}},{"node":{"frontmatter":{"title":"The Stormlight Archive","path":"/stormlight-archive"}}},{"node":{"frontmatter":{"title":"The Dresden Files","path":"/dresden-files"}}},{"node":{"frontmatter":{"title":"The Broken Earth Trilogy Review","path":"/broken-earth"}}}]}},"pathContext":{"tag":"Fantasy"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-fantasy-9d442987fadfd2ae91a5.js